import { Machine, assign } from 'xstate';
import { wpFetchRestApi, isWpSuccess } from '../../util';
;
export const supervisorVideoMeetingMachine = Machine({
    id: "supervisor-video-meeting",
    strict: true,
    initial: 'unknown',
    states: {
        unknown: {
            always: [
                { target: '#started.not_joined', cond: 'meetingHasStarted' },
                { target: 'finished', cond: 'meetingFinished' },
                { target: 'cancelled', cond: 'meetingCancelled' },
                { target: 'not_started' },
            ],
        },
        not_started: {
            initial: 'not_joined',
            states: {
                not_joined: {
                    on: {
                        JOIN: 'notifying_join',
                    }
                },
                notifying_join: {
                    invoke: {
                        id: 'notify-meeting-started',
                        src: 'notifyMeetingStarted',
                        onDone: { target: '#started.joined' },
                        onError: { target: 'error_notifying' },
                    },
                },
                error_notifying: {
                    on: {
                        JOIN: 'not_joined',
                    }
                },
            },
        },
        started: {
            id: "started",
            initial: 'not_joined',
            states: {
                not_joined: {
                    on: {
                        JOIN: 'joined',
                        FINISH: 'notifying_finish',
                    }
                },
                joined: {
                    on: {
                        LEAVE: 'hangup',
                    }
                },
                hangup: {
                    on: {
                        JOIN: 'not_joined',
                        FINISH: 'notifying_finish',
                    },
                },
                notifying_finish: {
                    // @ts-ignore
                    invoke: {
                        id: 'notify-meeting-finished',
                        src: 'notifyMeetingFinished',
                        onDone: '#finished',
                        onError: {
                            target: 'error_notifying',
                            actions: [
                                assign({
                                    error: (__, evt) => evt.data,
                                })
                            ],
                        }
                    },
                },
                error_notifying: {
                    on: {
                        JOIN: 'not_joined',
                        FINISH: 'notifying_finish',
                    }
                },
            },
        },
        finished: {
            id: 'finished'
        },
        cancelled: {},
    }
}, {
    guards: {
        //'meetingNotStarted': (ctx) => ctx.meetingInfo.state == "waiting_to_start",
        'meetingNotStarted': (ctx) => {
            console.log({ ctx });
            return ctx.meetingInfo.state == "waiting_to_start";
        },
        'meetingHasStarted': (ctx) => ctx.meetingInfo.state == "in_progress",
        'meetingFinished': (ctx) => ctx.meetingInfo.state == "finished",
        'meetingCancelled': (ctx) => ctx.meetingInfo.state == "cancelled",
    },
    actions: {},
    services: {
        notifyMeetingStarted: notifyMeetingStarted,
        notifyMeetingFinished: notifyMeetingFinished,
    },
});
export function createMachine(meetingInfo) {
    console.log("Creating machine");
    console.log({ meetingInfo });
    return supervisorVideoMeetingMachine.withContext({ meetingInfo });
}
async function notifyMeetingStarted(context) {
    const endpoint = 'meeting/' + context.meetingInfo.id + '/start';
    const result = await wpFetchRestApi(endpoint, 'PUT');
    if (isWpSuccess(result)) {
        return result;
    }
    throw new Error(result.message);
}
;
async function notifyMeetingFinished(context) {
    const endpoint = 'meeting/' + context.meetingInfo.id + '/end';
    const result = await wpFetchRestApi(endpoint, 'PUT');
    if (isWpSuccess(result)) {
        return result;
    }
    throw new Error(result.message);
}
;
